module.exports = __webpack_public_path__ + "assets/ab017e94f7ddc374c218a564fb63c1e4.png";